import styled from "styled-components";

export const StyledNumericRange = styled.div<{
    _width?: string;
}>`
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    grid-template-rows: auto;
    width: ${props => props._width ? props._width : "100%"};
    align-items: center;
`;